module.exports = __webpack_public_path__ + "img/04-title-02.05b82f85.png";